// config
import * as http from 'utils/http';
import config from 'config';

const assignTicketRegion = async ({ assignTicketRegionDto, ticket_id }) => {
  return http.post(
    `${config.API_URL}price-negotiation/tickets/${ticket_id}/assigned-areas/`,
    assignTicketRegionDto
  );
};

export default assignTicketRegion;
